import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Spinner, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faQuestionCircle, faExclamationTriangle, faLifeRing, faShieldAlt, faInfoCircle, faFileAlt, faClipboardList } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import styles from './UserManual.module.scss';

const UserManualPage = () => {
    const [manuals, setManuals] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('quick-start');
    const user = useSelector(state => state.authentication?.user);

    const iconMap = {
        'faBook': faBook,
        'faQuestionCircle': faQuestionCircle,
        'faLifeRing': faLifeRing,
        'faShieldAlt': faShieldAlt,
        'faExclamationTriangle': faExclamationTriangle,
        'faInfoCircle': faInfoCircle,
        'faFileAlt': faFileAlt,
        'faClipboardList': faClipboardList
    };

    useEffect(() => {
        loadManuals();
    }, []);

    const loadManuals = async () => {
        setLoading(true);
        setError(null);
        try {
            const auth = JSON.parse(localStorage.getItem('auth') || '{}');
            const token = auth.access_token;
            const baseUrl = process.env.REACT_APP_BASE_URL || '';
            const response = await axios.get(
                `${baseUrl}/api/user_manual?is_active=true`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (response.data.success && response.data.data) {
                setManuals(response.data.data);
            }
        } catch (err) {
            setError(err.response?.data?.message || "Error loading user manual");
            console.error("Error loading manuals:", err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <Container fluid className={styles['qa-container']}>
                <div className="text-center py-5">
                    <Spinner animation="border" variant="primary" />
                    <p className="mt-3 text-muted">Loading user manual...</p>
                </div>
            </Container>
        );
    }

    if (error) {
        return (
            <Container fluid className={styles['qa-container']}>
                <Alert variant="danger">
                    <Alert.Heading>Error Loading Manual</Alert.Heading>
                    <p>{error}</p>
                    <button className="btn btn-primary" onClick={loadManuals}>Retry</button>
                </Alert>
            </Container>
        );
    }

    // If we have data from API, render continuous scrolling document with left anchors
    const scrollToSection = (id) => {
        const el = document.getElementById(`section-${id}`);
        if (el) {
            // Offset so the section sits a bit higher than the top (account for headers)
            const offset = 100; // pixels
            const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: y, behavior: 'smooth' });
            setActiveTab(id);
        }
    };


    if (manuals && manuals.length > 0) {
        return (
            <Container fluid className={styles['qa-container']}>
                <Row>
                    <Col md={2}>
                        <div className={styles['manual-nav']}>
                            {/* <h5 className={styles['nav-title']}>Sections</h5> */}
                            {/*
                              Show manage button only to admin or QA users
                            */}
                            { (user?.is_admin || user?.is_admin_or_qa) && (
                                <div style={{ padding: '0 12px 12px' }}>
                                    <Link to="/user-manual/list" className="btn btn-sm btn-outline-primary w-100 mb-2">
                                        Manage Sections
                                    </Link>
                                </div>
                            )}
                            <ul className={styles['nav-list']}>
                                {manuals.map((manual) => (
                                    <li
                                        key={manual.id}
                                        className={`${styles['nav-item']} ${activeTab === manual.id ? styles['nav-item-active'] : ''}`}
                                    >
                                        <a href="#" onClick={(e) => { e.preventDefault(); scrollToSection(manual.id); }} className={styles['nav-link']} role="button" aria-label={`Go to ${manual.tab_name}`}>
                                            {manual.tab_name}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Col>
                    <Col md={10}>
                        <Card className={styles['qa-card']}>
                            {/* <Card.Header className={styles['card-header']}>
                                <h1>Prism User Manual</h1>
                                <p className={styles['subtitle']}>
                                    This user manual is a living document and will be updated as new features are released and system functionality evolves.
                                </p>
                            </Card.Header> */}
                            <Card.Body className={styles['card-body']}>
                                <div className={styles['continuous-scroll']}>
                                    {manuals.map((manual, index) => (
                                        <div
                                            key={manual.id}
                                            className={styles['manual-section']}
                                            id={`section-${manual.id}`}
                                        >
                                            <div
                                                className={styles['content-section']}
                                                dangerouslySetInnerHTML={{ __html: manual.content }}
                                            />
                                            {index < manuals.length - 1 && (
                                                <hr className={styles['section-divider']} />
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }

};

export default UserManualPage;

